var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v("\n    Facturas Canceladas\n  ")
      ]),
      _c("AppPagination", {
        staticClass: "is-centered",
        attrs: {
          "current-page": _vm.currentPage,
          "buttons-max": _vm.buttonsMax,
          "pages-total": _vm.totalPages
        },
        on: { change: _vm.goToPage }
      }),
      _c("table", { staticClass: "table is-fullwidth" }, [
        _vm._m(0),
        _c(
          "tbody",
          [
            _vm.isLoading
              ? _c("tr", [_vm._m(1)])
              : [
                  _vm.invoices.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          { staticClass: "empty", attrs: { colspan: "7" } },
                          [_vm._v("\n            Sin datos\n          ")]
                        )
                      ])
                    : _vm._l(_vm.invoices, function(invoice, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _vm._v(
                              "\n            " +
                                _vm._s(invoice.voucherSeries) +
                                "\n            -\n            " +
                                _vm._s(invoice.voucherConsecutive) +
                                "\n          "
                            )
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm._f("toHumanDate")(invoice.voucherDate))
                            )
                          ]),
                          _c("td", [_vm._v(_vm._s(invoice.receiverRfc))]),
                          _c("td", [_vm._v(_vm._s(invoice.receiverName))]),
                          _c("td", [_vm._v(_vm._s(_vm.getUuid(invoice)))]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("toCurrency")(
                                  invoice.voucherTotal,
                                  invoice.voucherCurrency
                                )
                              )
                            )
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.voucherTypeLabel(invoice.voucherType))
                            )
                          ]),
                          _c("td", [
                            invoice.voucherType === "P"
                              ? _c(
                                  "div",
                                  { staticClass: "actions" },
                                  [
                                    _c(
                                      "AppRadialMenu",
                                      {
                                        attrs: {
                                          size: 36,
                                          "item-size": 48,
                                          radius: 80,
                                          "angle-restriction": 50,
                                          rotate: -25
                                        }
                                      },
                                      [
                                        _c(
                                          "AppRadialMenuItem",
                                          {
                                            staticClass:
                                              "tooltip is-tooltip-primary has-background-primary has-text-white",
                                            attrs: {
                                              "data-tooltip":
                                                "Detalle de documento"
                                            }
                                          },
                                          [
                                            _c(
                                              "RouterLink",
                                              {
                                                staticClass: "action-option",
                                                attrs: {
                                                  to: {
                                                    name: _vm.getRoute(invoice),
                                                    params: { uuid: invoice.id }
                                                  }
                                                }
                                              },
                                              [
                                                _c("BIcon", {
                                                  staticClass:
                                                    "action-option-icon",
                                                  attrs: { icon: "eye" }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm.toRep(invoice)
                                          ? _c(
                                              "AppRadialMenuItem",
                                              {
                                                staticClass:
                                                  "tooltip is-tooltip-success has-background-success has-text-white",
                                                attrs: {
                                                  "data-tooltip": "Reemitir rep"
                                                }
                                              },
                                              [
                                                _c(
                                                  "RouterLink",
                                                  {
                                                    staticClass:
                                                      "action-option",
                                                    attrs: {
                                                      to: _vm.toRep(invoice)
                                                    }
                                                  },
                                                  [
                                                    _c("BIcon", {
                                                      staticClass:
                                                        "action-option-icon",
                                                      attrs: {
                                                        icon: "undo-variant"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            invoice.voucherType !== "P"
                              ? _c(
                                  "div",
                                  { staticClass: "buttons" },
                                  [
                                    _c(
                                      "RouterLink",
                                      {
                                        staticClass:
                                          "button is-info tooltip is-tooltip-info",
                                        attrs: {
                                          "data-tooltip":
                                            "Detalle de documento",
                                          to: {
                                            name: _vm.getRoute(invoice),
                                            params: { uuid: invoice.id }
                                          }
                                        }
                                      },
                                      [
                                        _c("BIcon", {
                                          attrs: { icon: "eye-off" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      })
                ]
          ],
          2
        )
      ]),
      _c("AppPagination", {
        staticClass: "is-centered",
        attrs: {
          "current-page": _vm.currentPage,
          "buttons-max": _vm.buttonsMax,
          "pages-total": _vm.totalPages
        },
        on: { change: _vm.goToPage }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Folio")]),
        _c("th", [_vm._v("Fecha")]),
        _c("th", [_vm._v("RFC Receptor")]),
        _c("th", [_vm._v("Razón social Cliente")]),
        _c("th", [_vm._v("Uuid")]),
        _c("th", [_vm._v("Total")]),
        _c("th", [_vm._v("Tipo")]),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "is-loading", attrs: { colspan: "8" } }, [
      _c("a", { staticClass: "button is-loading is-fullwidth" }, [
        _vm._v("\n            Cargando..\n          ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }